import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppSelector } from 'slices/commonSelectors';
import { selectCombinedUser } from 'slices/commonSelectors';
import { WorkspaceType } from 'types/workspace';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { Channel } from 'types/channels';

const keys = {
  customTeamSite: 'customTeamSite',
};

type GenerateCustomTeamSiteInput = {
  workspaceType: WorkspaceType;
  workspaceId: UUID;
  channels: Channel[];
  tenantId: UUID;
  description?: string;
  label?: string;
};

export const useGenerateCustomTeamSite = () => {
  const queryClient = useQueryClient();
  const userEmail = useAppSelector(selectCombinedUser).email_address;

  return useMutation<any, any, GenerateCustomTeamSiteInput>({
    mutationFn: async ({ workspaceType, workspaceId, tenantId, channels }) => {
      toast.info('Launching your custom Teams site');
      const response = await axios(config.apiGateway.customTeamSites, {
        method: 'POST',
        data: {
          workspaceType,
          workspaceId,
          tenantId,
          channels,
          userEmail,
        },
      });
      return response?.data;
    },
    onSuccess: ({ message }, { workspaceType, workspaceId }) => {
      toast.success(message);
      queryClient.invalidateQueries({
        queryKey: [keys.customTeamSite, workspaceType, workspaceId],
      });
    },
    onError: (error) => {
      toast.error(error.response.data.error);
    },
  });
};
